import { graphql } from "../gql";

export const createUserMutationDoc = graphql(`
  mutation createUser($input: CreateUserInput!) {
    createUser(input: $input) {
      user {
        id
      }
    }
  }
`);
